import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c1d7d62"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_2 = { class: "time-out-screen" }

import { computed, watch, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGameState } from '@/services/composition';

import UIPanelPause from '@/components/UIPanelPause/UIPanelPause.vue';
import UIPanelEndSuccess from '@/components/UIPanelEndSuccess/UIPanelEndSuccess.vue';
import Delay from '@/core/Delay';
import UIEscapeSuccess from './UIEscapeSuccess/UIEscapeSuccess.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()
const { t } = useI18n()

const elClass = computed(() => {
  return {
    'ending--failed': state.value.matches('end.failed')
  }
})

const isEndFailed = computed(() => {
  return state.value.matches('end.failed')
})

const showPanelFail = ref(false)
watch(isEndFailed, async () => {
  await Delay(3000)
  showPanelFail.value = isEndFailed.value
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "long-fade" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(['ending', _unref(elClass)])
      }, [
        _hoisted_1,
        (_unref(isEndFailed))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, _toDisplayString(_unref(t)('fail.claim')), 1)
              ]),
              (showPanelFail.value)
                ? (_openBlock(), _createBlock(UIPanelPause, {
                    key: 0,
                    class: "panel panel--failed"
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_unref(state).matches('end.initial'))
              ? (_openBlock(), _createBlock(UIEscapeSuccess, { key: 0 }))
              : (_unref(state).matches('end.success'))
                ? (_openBlock(), _createBlock(UIPanelEndSuccess, {
                    key: 1,
                    class: "panel"
                  }))
                : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ], 2)
    ]),
    _: 1
  }))
}
}

})